const CONSENT_KEY = 'pb_consent';

function getConsent() {
  return localStorage.getItem(CONSENT_KEY);
}

function setConsent(value) {
  localStorage.setItem(CONSENT_KEY, value);
}

function grantAnalyticsConsent() {
  const id = window.pbGa4Id;
  if (!id) return;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  s.onload = () => {
    window.gtag('js', new Date());
    window.gtag('config', id);
  };
  document.head.appendChild(s);
}

function hideBanner() {
  const banner = document.getElementById('cookie-consent');
  if (!banner) return;
  banner.classList.remove('is-visible');
  banner.setAttribute('aria-hidden', 'true');
}

function showBanner() {
  const banner = document.getElementById('cookie-consent');
  if (!banner) return;
  banner.classList.add('is-visible');
  banner.removeAttribute('aria-hidden');
}

export default function initCookieConsent() {
  const consent = getConsent();

  if (consent === 'all' || consent === 'necessary') {
    return;
  }

  if (!consent) {
    showBanner();
  }

  const acceptBtn = document.getElementById('cookie-accept-all');
  if (acceptBtn) {
    acceptBtn.addEventListener('click', () => {
      setConsent('all');
      grantAnalyticsConsent();
      hideBanner();
    });
  }

  const necessaryBtn = document.getElementById('cookie-accept-necessary');
  if (necessaryBtn) {
    necessaryBtn.addEventListener('click', () => {
      setConsent('necessary');
      hideBanner();
    });
  }

  document.querySelectorAll('[data-cookie-preferences]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      showBanner();
    });
  });

  window.pbOpenCookieConsent = showBanner;
}
